import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles/globals.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode data-oid="0po6y6c">
    <BrowserRouter data-oid="nn3ir9u">
      <App data-oid="jh78qzj" />
    </BrowserRouter>
  </React.StrictMode>,
);
